var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',{class:{ 'duration-timer': _vm.canEdit, 'duration-timer-closed': !_vm.canEdit || _vm.attendance?.end_datetime }},[_c('span',[_vm._v(_vm._s(this.timer))]),_vm._v(" "),_c('Clock')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }